export interface WarehouseProfile {
  id: string;
  staffName: string;
  role: string;
  avatarUrl?: string;
  status: 'Active' | 'Inactive' | 'Suspended';
  assignedWarehouse: string;
}

export interface PersonalInfo {
  staffName: string;
  employeeId: string;
  role: string;
  assignedWarehouse: string;
}

export interface ContactInfo {
  email: string;
  phone: string;
  department: string;
}

export interface NotificationPreference {
  id: string;
  label: string;
  enabled: boolean;
}

export interface SecurityOption {
  id: string;
  label: string;
}

export interface SettingsItem {
  id: string;
  icon: 'bell' | 'globe' | 'wifi' | 'gear';
  title: string;
  subtitle: string;
}

export const defaultNotificationPreferences: NotificationPreference[] = [
  { id: 'low-stock-alerts', label: 'Low Stock Alerts', enabled: true },
  { id: 'cycle-count-variance', label: 'Cycle Count Variance Alerts', enabled: true },
  { id: 'incomplete-picking', label: 'Incomplete Picking Alerts', enabled: true },
  { id: 'damaged-goods', label: 'Damaged Goods Alerts', enabled: true },
  { id: 'transfer-completion', label: 'Transfer Completion Needed', enabled: false },
];

export const defaultSecurityOptions: SecurityOption[] = [
  { id: 'change-password', label: 'Change Password' },
];

export const defaultSettingsItems: SettingsItem[] = [
  { id: 'notifications', icon: 'bell', title: 'Notifications', subtitle: 'Manage notification preferences' },
  { id: 'language', icon: 'globe', title: 'Language', subtitle: 'English (US)' },
  { id: 'offline-mode', icon: 'wifi', title: 'Offline Mode', subtitle: 'Sync when online' },
  { id: 'general', icon: 'gear', title: 'General Settings', subtitle: 'App preferences and defaults' },
];
